import { types, actions } from './requests'
export const CREATECOMMAND_TYPES = {
    ...types('CREATECOMMAND'),
}
export const CREATECOMMAND_ACTIONS = {
    ...actions('CREATECOMMAND'),
}